import { createContext, useContext } from "react";
import type { ReactNode } from "react";

export interface ChangePlanContextProps {
  isManagingMember?: boolean;
  subscription?: any;
}

const ChangePlanContext = createContext<ChangePlanContextProps>({});
ChangePlanContext.displayName = "ChangePlanContext";

export interface ChangePlanProviderProps {
  children: ReactNode;
  isManagingMember?: boolean;
  subscription: any;
}

export const ChangePlanContextProvider = ({
  subscription,
  isManagingMember,
  children,
}: ChangePlanProviderProps) => {
  const valuesToStore = {
    subscription,
    isManagingMember: Boolean(isManagingMember),
  };

  return (
    <ChangePlanContext.Provider value={valuesToStore}>
      {children}
    </ChangePlanContext.Provider>
  );
};

export const useChangePlanContext = () => useContext(ChangePlanContext);
